import '../pages/sitStyling.scss';
import React, {useEffect, useState} from "react";
import {observer} from "mobx-react-lite";
import {MainComponent} from "../../components/main/MainComponent";
import {IconButton, Menu, MenuItem, Tab, Tabs} from "@mui/material";
import SettingsIcon from '@mui/icons-material/Settings';
import {generatePath, useLocation, useNavigate} from "react-router";
import {sitRoutes} from "./sitRoutes";
import {useSitStores} from "../../stores";
import {CurrencyComponent} from "../../components/currency-component/CurrencyComponent";
import {MainPageFacade} from "../../components/main/page/MainPageFacade.tsx";
import {CARD_CONFIG} from "../../components/dashboard/DashboardCardConfigs.tsx";
import type {KpiBoxedValue} from "../../components/kpi-boxed-values/KpiBoxedValues.tsx";
import {KpiBoxedValues} from "../../components/kpi-boxed-values/KpiBoxedValues.tsx";

export type SitRouteWrapperProps = {
    children?: React.ReactNode
}
export const SitRouteWrapper: React.FC<SitRouteWrapperProps> = observer(({children}) => {
    const {ccStore, initiativeListStore, fbStore} = useSitStores();
    const navigate = useNavigate();
    const location = useLocation();
    const tabLocations = [
        sitRoutes.sit_initiatives,
        sitRoutes.sit_targets,
        sitRoutes.sit_financial,
        sitRoutes.sit_pipeline_dashboard,
        sitRoutes.sit_approval,
    ];
    const [menuOpen, setMenuOpen] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    useEffect(() => {
        ccStore.loadInitialData();
        initiativeListStore.reloadData(true);
        fbStore.reloadData(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // TODO: Experiment with the correct deduction of the Role before rending any View (on staging)

    const kpiValues = React.useMemo<KpiBoxedValue[]>(() => [
        {
            title: 'Total Savings',
            subtitle: <CurrencyComponent
                v={initiativeListStore.initiativeKpiRM.result?.total_savings ?? 0}
                nDigits={3}/>
        }, {
            title: 'Number of Initiatives',
            subtitle: initiativeListStore.initiativeKpiRM.result?.count ?? 0
        }, {
            title: 'Pending Approvals',
            subtitle: initiativeListStore.initiativeKpiRM.result?.pending ?? 0
        },
    ], [initiativeListStore.initiativeKpiRM.result]);


    return (
        <MainComponent>
            {tabLocations.indexOf(location.pathname) >= 0 &&
                <MainPageFacade
                    title={CARD_CONFIG['sit'].title}
                    actionBarEnd={<>
                        <IconButton
                            id="menu-button"
                            aria-controls={menuOpen ? 'basic-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={menuOpen ? 'true' : undefined}
                            onClick={(event) => {
                                setMenuOpen(!menuOpen);
                                setAnchorEl(event.currentTarget);
                            }}>
                            <SettingsIcon/>
                        </IconButton>
                    </>}
                    className="sit-page">
                    <Menu
                        id="settings-menu"
                        anchorEl={anchorEl}
                        open={menuOpen}
                        onClose={() => {
                            setMenuOpen(false);
                            setAnchorEl(null);
                        }}
                        MenuListProps={{
                            'aria-labelledby': 'menu-button',
                        }}>
                        <MenuItem onClick={() => navigate(generatePath(sitRoutes.sit_settings_conversion_rates))}>
                            Conversion rates
                        </MenuItem>
                    </Menu>

                    <KpiBoxedValues values={kpiValues}/>

                    <Tabs
                        component="section"
                        className="sit-page-section"
                        value={location.pathname}
                        aria-label="wrapped label tabs"
                        onChange={(event, newValue) => {
                            navigate(generatePath(newValue));
                        }}>
                        <Tab label="TARGETS" value={sitRoutes.sit_targets}/>
                        <Tab label="INITIATIVES" value={sitRoutes.sit_initiatives}/>
                        <Tab label="FINANCIAL VIEW" value={sitRoutes.sit_financial}/>
                        <Tab label="Pipeline view" value={sitRoutes.sit_pipeline_dashboard}/>
                        <Tab label="APPROVAL" value={sitRoutes.sit_approval}/>
                    </Tabs>
                    {children}
                </MainPageFacade>}
            {tabLocations.indexOf(location.pathname) < 0 && children}
        </MainComponent>
    );
});
